import TextField from '@mui/material/TextField'

interface Props {
  label: string
  value: any
  filterName: string
  onFilterChange: (any, submit?: boolean) => void
}

export const FilterSearch = ({
  label,
  value,
  filterName,
  onFilterChange,
}: Props) => {
  const onChange = (e) => {
    onFilterChange({ [filterName]: e.target.value })
  }

  const handleKeyDown = (e) => {
    const ENTER_KEY = 13

    if (e.keyCode === ENTER_KEY) {
      onFilterChange({ [filterName]: value }, true)
    }
  }

  return (
    <TextField
      fullWidth
      variant="standard"
      data-testid="filterfield"
      label={label}
      value={value}
      onChange={onChange}
      onKeyDown={handleKeyDown}
    />
  )
}
